// Organisations store a CountryId, keyed by ISO 3166-1 numeric code.
export interface ICountry {
  id: number;
  name: string;
}

export const COUNTRY_LIST: ICountry[] = [
  { id: 4, name: "Afghanistan" },
  { id: 8, name: "Albania" },
  { id: 12, name: "Algeria" },
  { id: 20, name: "Andorra" },
  { id: 24, name: "Angola" },
  { id: 28, name: "Antigua and Barbuda" },
  { id: 32, name: "Argentina" },
  { id: 51, name: "Armenia" },
  { id: 36, name: "Australia" },
  { id: 40, name: "Austria" },
  { id: 31, name: "Azerbaijan" },
  { id: 44, name: "Bahamas" },
  { id: 48, name: "Bahrain" },
  { id: 50, name: "Bangladesh" },
  { id: 52, name: "Barbados" },
  { id: 112, name: "Belarus" },
  { id: 56, name: "Belgium" },
  { id: 84, name: "Belize" },
  { id: 204, name: "Benin" },
  { id: 64, name: "Bhutan" },
  { id: 68, name: "Bolivia" },
  { id: 70, name: "Bosnia and Herzegovina" },
  { id: 72, name: "Botswana" },
  { id: 76, name: "Brazil" },
  { id: 96, name: "Brunei" },
  { id: 100, name: "Bulgaria" },
  { id: 854, name: "Burkina Faso" },
  { id: 108, name: "Burundi" },
  { id: 132, name: "Cabo Verde" },
  { id: 116, name: "Cambodia" },
  { id: 120, name: "Cameroon" },
  { id: 124, name: "Canada" },
  { id: 140, name: "Central African Republic" },
  { id: 148, name: "Chad" },
  { id: 152, name: "Chile" },
  { id: 156, name: "China" },
  { id: 170, name: "Colombia" },
  { id: 174, name: "Comoros" },
  { id: 178, name: "Congo" },
  { id: 180, name: "Congo (Democratic Republic)" },
  { id: 188, name: "Costa Rica" },
  { id: 384, name: "Côte d'Ivoire" },
  { id: 191, name: "Croatia" },
  { id: 192, name: "Cuba" },
  { id: 196, name: "Cyprus" },
  { id: 203, name: "Czechia" },
  { id: 208, name: "Denmark" },
  { id: 262, name: "Djibouti" },
  { id: 212, name: "Dominica" },
  { id: 214, name: "Dominican Republic" },
  { id: 218, name: "Ecuador" },
  { id: 818, name: "Egypt" },
  { id: 222, name: "El Salvador" },
  { id: 226, name: "Equatorial Guinea" },
  { id: 232, name: "Eritrea" },
  { id: 233, name: "Estonia" },
  { id: 748, name: "Eswatini" },
  { id: 231, name: "Ethiopia" },
  { id: 242, name: "Fiji" },
  { id: 246, name: "Finland" },
  { id: 250, name: "France" },
  { id: 266, name: "Gabon" },
  { id: 270, name: "Gambia" },
  { id: 268, name: "Georgia" },
  { id: 276, name: "Germany" },
  { id: 288, name: "Ghana" },
  { id: 300, name: "Greece" },
  { id: 308, name: "Grenada" },
  { id: 320, name: "Guatemala" },
  { id: 324, name: "Guinea" },
  { id: 624, name: "Guinea-Bissau" },
  { id: 328, name: "Guyana" },
  { id: 332, name: "Haiti" },
  { id: 340, name: "Honduras" },
  { id: 344, name: "Hong Kong" },
  { id: 348, name: "Hungary" },
  { id: 352, name: "Iceland" },
  { id: 356, name: "India" },
  { id: 360, name: "Indonesia" },
  { id: 364, name: "Iran" },
  { id: 368, name: "Iraq" },
  { id: 372, name: "Ireland" },
  { id: 376, name: "Israel" },
  { id: 380, name: "Italy" },
  { id: 388, name: "Jamaica" },
  { id: 392, name: "Japan" },
  { id: 400, name: "Jordan" },
  { id: 398, name: "Kazakhstan" },
  { id: 404, name: "Kenya" },
  { id: 296, name: "Kiribati" },
  { id: 414, name: "Kuwait" },
  { id: 417, name: "Kyrgyzstan" },
  { id: 418, name: "Laos" },
  { id: 428, name: "Latvia" },
  { id: 422, name: "Lebanon" },
  { id: 426, name: "Lesotho" },
  { id: 430, name: "Liberia" },
  { id: 434, name: "Libya" },
  { id: 438, name: "Liechtenstein" },
  { id: 440, name: "Lithuania" },
  { id: 442, name: "Luxembourg" },
  { id: 450, name: "Madagascar" },
  { id: 454, name: "Malawi" },
  { id: 458, name: "Malaysia" },
  { id: 462, name: "Maldives" },
  { id: 466, name: "Mali" },
  { id: 470, name: "Malta" },
  { id: 584, name: "Marshall Islands" },
  { id: 478, name: "Mauritania" },
  { id: 480, name: "Mauritius" },
  { id: 484, name: "Mexico" },
  { id: 583, name: "Micronesia" },
  { id: 498, name: "Moldova" },
  { id: 492, name: "Monaco" },
  { id: 496, name: "Mongolia" },
  { id: 499, name: "Montenegro" },
  { id: 504, name: "Morocco" },
  { id: 508, name: "Mozambique" },
  { id: 104, name: "Myanmar" },
  { id: 516, name: "Namibia" },
  { id: 520, name: "Nauru" },
  { id: 524, name: "Nepal" },
  { id: 528, name: "Netherlands" },
  { id: 554, name: "New Zealand" },
  { id: 558, name: "Nicaragua" },
  { id: 562, name: "Niger" },
  { id: 566, name: "Nigeria" },
  { id: 408, name: "North Korea" },
  { id: 807, name: "North Macedonia" },
  { id: 578, name: "Norway" },
  { id: 512, name: "Oman" },
  { id: 586, name: "Pakistan" },
  { id: 585, name: "Palau" },
  { id: 275, name: "Palestine" },
  { id: 591, name: "Panama" },
  { id: 598, name: "Papua New Guinea" },
  { id: 600, name: "Paraguay" },
  { id: 604, name: "Peru" },
  { id: 608, name: "Philippines" },
  { id: 616, name: "Poland" },
  { id: 620, name: "Portugal" },
  { id: 634, name: "Qatar" },
  { id: 642, name: "Romania" },
  { id: 643, name: "Russia" },
  { id: 646, name: "Rwanda" },
  { id: 659, name: "Saint Kitts and Nevis" },
  { id: 662, name: "Saint Lucia" },
  { id: 670, name: "Saint Vincent and the Grenadines" },
  { id: 882, name: "Samoa" },
  { id: 674, name: "San Marino" },
  { id: 678, name: "Sao Tome and Principe" },
  { id: 682, name: "Saudi Arabia" },
  { id: 686, name: "Senegal" },
  { id: 688, name: "Serbia" },
  { id: 690, name: "Seychelles" },
  { id: 694, name: "Sierra Leone" },
  { id: 702, name: "Singapore" },
  { id: 703, name: "Slovakia" },
  { id: 705, name: "Slovenia" },
  { id: 90, name: "Solomon Islands" },
  { id: 706, name: "Somalia" },
  { id: 710, name: "South Africa" },
  { id: 410, name: "South Korea" },
  { id: 728, name: "South Sudan" },
  { id: 724, name: "Spain" },
  { id: 144, name: "Sri Lanka" },
  { id: 729, name: "Sudan" },
  { id: 740, name: "Suriname" },
  { id: 752, name: "Sweden" },
  { id: 756, name: "Switzerland" },
  { id: 760, name: "Syria" },
  { id: 158, name: "Taiwan" },
  { id: 762, name: "Tajikistan" },
  { id: 834, name: "Tanzania" },
  { id: 764, name: "Thailand" },
  { id: 626, name: "Timor-Leste" },
  { id: 768, name: "Togo" },
  { id: 776, name: "Tonga" },
  { id: 780, name: "Trinidad and Tobago" },
  { id: 788, name: "Tunisia" },
  { id: 792, name: "Turkey" },
  { id: 795, name: "Turkmenistan" },
  { id: 798, name: "Tuvalu" },
  { id: 800, name: "Uganda" },
  { id: 804, name: "Ukraine" },
  { id: 784, name: "United Arab Emirates" },
  { id: 826, name: "United Kingdom" },
  { id: 840, name: "United States" },
  { id: 858, name: "Uruguay" },
  { id: 860, name: "Uzbekistan" },
  { id: 548, name: "Vanuatu" },
  { id: 336, name: "Vatican City" },
  { id: 862, name: "Venezuela" },
  { id: 704, name: "Vietnam" },
  { id: 887, name: "Yemen" },
  { id: 894, name: "Zambia" },
  { id: 716, name: "Zimbabwe" },
];

export const AUSTRALIA_COUNTRY_ID = 36;
